// extracted by mini-css-extract-plugin
export default {"modal-overlay":"Modal_modal-overlay__Czr9V","modal-content":"Modal_modal-content__CnsiF","close-button":"Modal_close-button__EOjfu"};